import classnames from 'classnames';
import React from 'react';
import Icon from '@ant-design/icons';
import NewSvg from '@icons/new-icon.svg';
import HomeIcon from '@icons/home/home.svg';
import { NavLink, NavLinkProps } from 'react-router-dom';

import styles from './index.less';

interface INavTabProps extends NavLinkProps {
  disabled?: boolean;
}
const getNewIcon = (route) => {
  if (route.includes('visual-activation')) {
    return (
      <Icon
        key={'home-icon-2'}
        className={classnames(styles.homeIcon, {
          [styles.active]: window.location.pathname.includes(route),
        })}
        component={NewSvg}
        style={{
          fontSize: '28px',
          paddingRight: '2px',
          height: '19px',
          verticalAlign: 'top',
          overflow: 'hidden',
          marginLeft: '-5px',
          paddingTop: '4px',
        }}
        data-test-id="new-icon"
      />
    );
  } else if (route.includes('home')) {
    return (
      <Icon
        key="home"
        className={classnames(styles.homeIcon, {
          [styles.active]: window.location.pathname.includes(route),
        })}
        component={HomeIcon}
        style={{
          fontSize: '22px',
          verticalAlign: '-6px',
        }}
        data-test-id="home"
      />
    );
  }
  return null;
};

const NavTab: React.FC<INavTabProps> = (props) => {
  const getClassName = (isActive) => {
    return classnames(
      styles.tab,
      { [styles.active]: isActive },
      { [styles.disabled]: props.disabled },
    );
  };
  return (
    <NavLink {...props} className={({ isActive }) => getClassName(isActive)}>
      {getNewIcon(props.to as string)}
      {props.children}
    </NavLink>
  );
};

export default NavTab;
